"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ScheduledSubscriptionStore = /*#__PURE__*/function (_RootStore) {
  function ScheduledSubscriptionStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, ScheduledSubscriptionStore);
    _this = _callSuper(this, ScheduledSubscriptionStore);
    _this.config = {
      model: _models.Subscription,
      deserialize: true,
      GET: {
        index: '/scheduled_subscriptions'
      },
      DELETE: {
        destroy: '/scheduled_subscriptions/:scheduledSubscriptionId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(ScheduledSubscriptionStore, _RootStore);
  return (0, _createClass2["default"])(ScheduledSubscriptionStore, [{
    key: "cancel",
    value: function () {
      var _cancel = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(params) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.apiPromise(params, 'DELETE', 'destroy');
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function cancel(_x) {
        return _cancel.apply(this, arguments);
      }
      return cancel;
    }()
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new ScheduledSubscriptionStore();